<template>
  <div id="admin" class="top-spaced">
    <menu-admin />
    <section class="int-form" style="margin-top: 30px; ">
      <div class="container">
        <div class="text-right d-print-none action-badges">
          <a
            id="changePrices"
            class="badge badge-info"
            href="#"
            style="color: white !important;"
            data-toggle="modal"
            data-target="#pricesModal"
          >
            <i class="fa fa-usd" aria-hidden="true"></i> Alterar preços
          </a>
          <a
            class="badge badge-info"
            href="javascript:window.print();"
            style="color: white !important;"
          >
            <i class="fa fa-print" aria-hidden="true"></i> Imprimir
          </a>
        </div>
        <!-- Modal -->
        <div
          class="modal fade"
          id="pricesModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="pricesModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5
                  class="modal-title"
                  id="pricesModalLabel"
                >Alteração em lote dos preços das publicações</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label for="percentage">Ajuste percentual para compra e renovação:</label>
                  <div class="input-group" style="margin-bottom: 10px">
                    <div class="input-group-prepend">
                      <span class="input-group-text">%</span>
                    </div>
                    <input
                      type="number"
                      class="form-control"
                      id="percentage"
                      v-model="percentage"
                      placeholder="100"
                    />
                    <span class="errorForm" style="width: 100%;"></span>
                  </div>
                </div>
                <div>
                  <strong>Simulação:</strong>
                  <br />
                  Valor atual: R$ 80,00 | Novo Valor: R$ {{ new_value_example | formatPrice }}
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  id="hideModal"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >Close</button>
                <button type="button" class="btn btn-primary" @click="price_refactor">Alterar Preços</button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 title-report">
          <h5>Publicações x Preços</h5>
          <br />

          <table
            class="table table-bordered table-sm table-hover"
            style="background: white; font-size: 0.8em"
          >
            <tr v-show="!publications.length">
              <td class="text-center" colspan="4">Nenhuma publicação encontrada</td>
            </tr>
            <thead v-show="publications.length">
              <tr>
                <th class="text-center" width="100" scope="col">Publicação</th>
                <th class="text-center">Nome</th>
                <th class="text-center">Revisao</th>
                <th class="text-center">Peso</th>
                <th class="text-center">Atualização</th>
                <th class="text-center">$ Compra</th>
                <th class="text-center">$ Renovação</th>
              </tr>
            </thead>
            <tbody v-show="publications.length">
              <tr v-for="publication in publications" v-bind:key="publication.id">
                <td class="text-center">#{{publication.id}}</td>
                <td>{{publication.name}}</td>
                <td class="text-center">{{publication.version}}</td>
                <td class="text-center">
                  <span v-show="publication.weight > 0">{{publication.weight | formatPrice}}Kg</span>
                </td>
                <td class="text-center">{{publication.date | formatDate}}</td>
                <td class="text-center">R$ {{publication.price | formatPrice}}</td>
                <td class="text-center">R$ {{publication.price_signature | formatPrice}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
    <footer-admin />
  </div>
</template>

<script>
import menuAdmin from "../admin/common/menu-admin";
import footerAdmin from "../admin/common/footer-admin";
import mixins from "../../helpers/mixins";
import reports from "../../api/reports";
import publication from "../../api/publication";

export default {
  name: "PublicationPrice",
  mixins: [mixins],
  data() {
    return {
      publications: {},
      percentage: 100,
    };
  },
  components: { menuAdmin, footerAdmin },
  methods: {
    getPublications() {
      reports
        .publication_price()
        .then((response) => {
          this.publications = response.data;
        })
        .catch((errors) => {
          this.formErrors(errors);
        });
    },
    price_refactor() {
      if (
        confirm("CUIDADO! Tem certeza que deseja reajustar todos os valores?")
      ) {
        publication
          .price_refactor({ percentage: this.percentage })
          .then((response) => {
            console.log(response);
            $("#pricesModal").modal("hide");
            this.getPublications();
          })
          .catch((errors) => {
            this.formErrors(errors);
          });
      }
    },
  },
  computed: {
    new_value_example: function () {
      let price = 80.0;
      return (price * this.percentage) / 100;
    },
  },
  mounted() {
    this.getPublications();
  },
};
</script>

<style scoped>
.action-badges {
  margin-top: 80px;
  padding-top: 10px;
  z-index: 1;
  position: relative;
}

.title-report {
  margin-top: -20px;
}

@media screen and (max-width: 999px) {
  .action-badges {
    margin-top: 100px;
    padding-top: 0px;
    padding-bottom: 10px;
    z-index: 1;
    position: relative;
  }

  .title-report {
    margin-top: 0;
  }
}
</style>